import { createSlice } from "@reduxjs/toolkit";


const converSationSlice = createSlice({
    name: 'conversations',
    initialState: {
        conversations: null,
        inProgress: false,
        errorMessage: undefined,
        conversationCategory: "EngagementSpecific",
        fopFilter: "combined"
    },
    reducers: {
        clearConversations: (state: any, action) => {
            state.conversations = null;
            if(action?.payload?.notClearCategory !== true) {
                state.conversationCategory = "EngagementSpecific";
            }
        },
        setConversationCategory: (state: any, action: any) => {
            state.conversationCategory = action.payload;
        },
        setConversationsData: (state: any, action: any) => {
            state.conversations = action.payload;
            return;
        },
        setFopFilter: (state: any, action: any) => {
            state.fopFilter = action.payload;
        },
        updateConversationContent: (state: any, action: any) => {
            let conversations = state.conversations;
            const itemIndex = conversations.findIndex((item: any) => item?.message?.component === action.payload.component);
            conversations[itemIndex].message.content = action.payload.content;
            state.conversations = conversations;
            return;
        },
        addConversationsMessage: (state: any, action: any) => {
            const {message, type, timeStamp, user} = action.payload;
            const {conversations} = state;
            if(conversations === null) {
                state.conversations = [
                    {
                        message: {
                            component: "option-select",
                            content: {
                                options: [
                                    {
                                        value: "ESG",
                                        label: "ESG"
                                    },
                                    {
                                        value: "SAP",
                                        label: "SAP"
                                    },
                                    {
                                        value: "Cyber",
                                        label: "Cyber"
                                    },
                                    {
                                        value: "Risk",
                                        label: "Risk"
                                    },
                                ],
                                title: `Hi ${user?.givenName ?? "User"}, Welcome to MS AI Core`,
                                subtitle: "How can I help you. Select one from the below, I can support in the following areas"
                            }
                        },
                        type: "received",
                        timeStamp: new Date().getTime()
                    },
                    {
                        message,
                        type,
                        timeStamp
                    },
                ];
                return;
            }
            let msgs: any = action.payload;
            if(msgs?.length) {
                state.conversations = state.conversations.concat(msgs);
                return;
            } else {
                state.conversations.push(action.payload)
            }
        },
        setErrorMessage: (state: any, payload: any) => {
            state.errorMessage = payload;
        },
        setProgress: (state: any, action: any) => {
            state.inProgress = action.payload;
        }
    }
})

export const { updateConversationContent, addConversationsMessage, setConversationsData, setFopFilter, setProgress, clearConversations, setConversationCategory } = converSationSlice.actions
export default converSationSlice.reducer;
export const selectConversations = state => state.conversations.conversations;
export const selectConversationCategory = state => state.conversations.conversationCategory;
export const selectFopFilter = state => state.conversations.fopFilter;